import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TransloadOrders_ds_get_task_by_task_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { task_id: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualSourceLicensePlateId?: number, ActualTargetLicensePlateId?: number, StatusId?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.task_id)) {
      missingRequiredInParams.push('\'task_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_get_task_by_task_id/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      task_id: number    }) {
        if(isNil(inParams.task_id)) {
          return true; 
        }
      return false;
    }
}
